import Card from '../../images/payment-logos/svg/card.svg';
import Invoice from '../../images/payment-logos/svg/invoice.svg';
import PayPal from '../../images/payment-logos/svg/paypal.svg';
import Sepa from '../../images/payment-logos/svg/sepa.svg';
import Amazon from '../../images/payment-logos/amazon.png';
import Google from '../../images/payment-logos/svg/google.svg';
import Apple from '../../images/payment-logos/svg/apple.svg';
import Klarna from '../../images/payment-logos/svg/klarna_white.svg';
import Ideal from '../../images/payment-logos/svg/ideal.svg';
import Bancontact from '../../images/payment-logos/svg/bancontact.svg';
import CartaDelDocente from '../../images/payment-logos/svg/carta_del_docente.svg';
import KushkiCashImage from '../../images/kushki/cash.png';
import KushkiTransferImage from '../../images/kushki/transfer.png';
import KushkiCardImage from '../../images/kushki/card.png';
import { AVAILABLE_WORLDS } from '../../languages/constants';
import { world } from '../../languages';
import isProduction from '../../utils/is-production';
import { PaymentOptionType } from '../../utils/enhanced-ecommerce';
import { PAYMENT_METHOD_KEYS } from '../../constants/payment-method-keys';

export type PaymentMethods = {
    [key in PAYMENT_METHOD_KEYS]: PaymentOptionType;
};

export const AVAILABLE_PAYMENT_METHODS: PaymentMethods = {
    [PAYMENT_METHOD_KEYS.AMAZON_PAY]: {
        id: PAYMENT_METHOD_KEYS.AMAZON_PAY,
        img: Amazon,
        title: 'Amazon Pay' },
    [PAYMENT_METHOD_KEYS.INVOICE]: {
        id: PAYMENT_METHOD_KEYS.INVOICE,
        img: Invoice,
        title: 'Kauf auf Rechnung'
    },
    [PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT]: {
        id: 'PayPal',
        img: PayPal,
        title: 'PayPal'
    },
    [PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_SEPA]: {
        id: PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_SEPA,
        img: Sepa,
        title: world === AVAILABLE_WORLDS.DE ? 'SEPA Lastschrift' : 'Direct Debit'
    },
    [PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD]: {
        id: 'cc',
        img: Card,
        title: 'Credit Card'
    },
    [PAYMENT_METHOD_KEYS.GOOGLE_PAY]: {
        id: PAYMENT_METHOD_KEYS.GOOGLE_PAY,
        img: Google,
        title: 'Google Pay'
    },
    [PAYMENT_METHOD_KEYS.APPLE_PAY]: {
        id: PAYMENT_METHOD_KEYS.APPLE_PAY,
        img: Apple,
        title: 'Apple Pay'
    },
    [PAYMENT_METHOD_KEYS.KLARNA_PAY]: {
        id: PAYMENT_METHOD_KEYS.KLARNA_PAY,
        img: Klarna,
        title: 'Klarna Pay Now'
    },
    [PAYMENT_METHOD_KEYS.SEPA_PAY]: {
        id: PAYMENT_METHOD_KEYS.SEPA_PAY,
        img: Sepa,
        title: world === AVAILABLE_WORLDS.DE ? 'SEPA Lastschrift' : 'Direct Debit'
    },
    [PAYMENT_METHOD_KEYS.CARD]: {
        id: PAYMENT_METHOD_KEYS.CARD,
        img: Card,
        title: 'Credit Card',
        translation: 'payment.paymentForm.creditCard'
    },
    [PAYMENT_METHOD_KEYS.IDEAL]: {
        id: PAYMENT_METHOD_KEYS.IDEAL,
        img: Ideal,
        title: 'iDEAL'
    },
    [PAYMENT_METHOD_KEYS.BANCONTACT_CARD]: {
        id: PAYMENT_METHOD_KEYS.BANCONTACT_CARD,
        img: Bancontact,
        title: 'Bancontact card'
    },
    [PAYMENT_METHOD_KEYS.BANCONTACT_MOBILE]: {
        id: PAYMENT_METHOD_KEYS.BANCONTACT_MOBILE,
        img: Bancontact,
        title: 'Bancontact mobile'
    },
    [PAYMENT_METHOD_KEYS.CARTA_DEL_DOCENTE]: {
        id: PAYMENT_METHOD_KEYS.CARTA_DEL_DOCENTE,
        img: CartaDelDocente,
        title: 'Carta del Docente'
    },
    [PAYMENT_METHOD_KEYS.KUSHKI_CARD]: {
        id: PAYMENT_METHOD_KEYS.KUSHKI_CARD,
        img: KushkiCardImage,
        title: 'Tarjeta de Crédito/Débito'
    },
    [PAYMENT_METHOD_KEYS.KUSHKI_CASH]: {
        id: PAYMENT_METHOD_KEYS.KUSHKI_CASH,
        img: KushkiTransferImage,
        title: 'Pago en efectivo'
    },
    [PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER]: {
        id: PAYMENT_METHOD_KEYS.KUSHKI_TRANSFER,
        img: KushkiCashImage,
        title: 'Transferencia Bancaria'
    },
};

export const PAYPAL_CLIENT_IDS = {
    PRODUCTION: 'AXw19qB0eGaMP_vwCic84J3xH-yOhHV4PzhEDkyOf0_VLu0twsFNiUwpkV202p24t0imOSIhrcbtIZ6-',
    STAGING: 'AUMveu6o-Xpvy5a_GQj8MRurGLFEcBJp-EeDzgPLUQZuDWndAS-CJ_jrPPLJf4NISwJlG-Q7IpDjsOfq'
};

export const SUCCESS_PAGE_DEEPLINKS = {
    REGULAR: 'com.lmp.buyer://payment-success'
};

export const ADYEN_CLIENT_KEY = isProduction()
    ? 'live_45GTHLQCNRERJD5LDP7MHTSAJMLDCLPA'
    : 'test_E4VKMCYNFVGWZLH7PPHXZKVY4MNFI5YH';
export const ADYEN_ENVIRONMENT = isProduction() ? 'live' : 'test';
